import { Component, Input, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.css'],
})
export class TooltipComponent {
  @Input() text: string = '';
  show = false;
  timeout: any;

  mounted = true;

  constructor(
    private cdr: ChangeDetectorRef,
  ) { }

  onHover() {
    this.show = true;
    this.mounted = true;
  }

  onLeaving() {
    this.timeout = setTimeout(() => {
      this.show = false;
      this.cdr.detectChanges();
    }, 300);

    this.timeout = setTimeout(() => {
      this.mounted = false;
      this.cdr.detectChanges();
    }, 600);
  }

  splitBreakLines(text: string): string[] {
    const result = text.split('\\n').reduce<string[]>((out, texto) => [...out, ...texto.split('\n')], [])
      .reduce<string[]>((out, textoo) => [...out, ...new Set([textoo, ''])], []);
    result.pop();
    return result;
  }
}
